import React from 'react';

function InventoryList({ inventories, onSelect, onDelete, onCreateNew, onEditItemTypes }) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h2>Your Inventories</h2>
        <button className="btn" onClick={onCreateNew}>
          Create New Inventory
        </button>
      </div>

      {inventories.length === 0 ? (
        <div className="card">
          <p>No inventories yet. Create your first inventory to get started!</p>
        </div>
      ) : (
        <div className="inventory-list">
          {inventories.map(inventory => (
            <div key={inventory.id} className="inventory-card">
              <h3>{inventory.name}</h3>
              <p>{inventory.description}</p>
              <div style={{ marginBottom: '0.5rem' }}>
                <strong>Item Types:</strong>
                {inventory.item_types && inventory.item_types.length > 0 ? (
                  <div style={{ marginTop: '0.25rem' }}>
                    {inventory.item_types.map((itemType, index) => (
                      <span 
                        key={itemType.id}
                        style={{
                          display: 'inline-block',
                          backgroundColor: itemType.is_default ? '#e8f4f8' : '#f5f5f5',
                          border: itemType.is_default ? '1px solid #0066cc' : '1px solid #ddd',
                          color: itemType.is_default ? '#0066cc' : '#333',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '4px',
                          fontSize: '0.8rem',
                          marginRight: '0.5rem',
                          marginBottom: '0.25rem'
                        }}
                      >
                        {itemType.name}
                        {itemType.is_default && ' (Default)'}
                        <span style={{ opacity: 0.7, marginLeft: '0.25rem' }}>
                          ({itemType.fields?.length || 0} fields)
                        </span>
                      </span>
                    ))}
                  </div>
                ) : (
                  <span style={{ color: '#888', fontSize: '0.9rem' }}>No item types</span>
                )}
              </div>
              {inventory.location_type_name && (
                <p><strong>Location Type:</strong> {inventory.location_type_name} ({inventory.locations ? inventory.locations.length : 0} locations)</p>
              )}
              <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                <button className="btn" onClick={() => onSelect(inventory)}>
                  View Items
                </button>
                <button 
                  className="btn btn-secondary" 
                  onClick={() => onEditItemTypes(inventory)}
                  style={{ fontSize: '0.8rem' }}
                >
                  Edit Item Types
                </button>
                <button 
                  className="btn btn-danger" 
                  onClick={() => {
                    if (window.confirm('Are you sure you want to delete this inventory?')) {
                      onDelete(inventory.id);
                    }
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default InventoryList;